import { BaseModel } from '@/models/BaseModel';
import { BaseCollection } from './BaseCollection';
import type { MutationsObject } from '@kp/js-model';
import type { Dayjs } from 'dayjs';
import dayjs from 'dayjs';
import { createModel } from '@kp/js-model';

export class KorrekturWerteStromerzeugung extends BaseModel {
    // properties
    id: number | null = null;
    created: Dayjs | null = null;
    modified: Dayjs | null = null;
    creator_id: number | null = null;
    modifier_id: number | null = null;

    jahr: number | null = null;
    kanton_id: number | null = null;
    gemeinde_id: number | null = null;
    referenz: string | null = null;
    technologie_stromerzeugung_id: number | null = null;
    inbetriebnahme: Dayjs | null = null;
    leistung: number | null = null;
    produktion: number | null = null;
    bemerkung: string | null = null;

    // view fields
    kanton_kuerzel: string | null = null;
    kanton: string | null = null;
    gemeinde: string | null = null;
    technologie_stromerzeugung: string | null = null;

    public mutations(): MutationsObject {
        return {
            created: (val) => dayjs(val),
            modified: (val) => dayjs(val),
            inbetriebnahme: (val) => dayjs(val),
        };
    }

    getClassName(): string {
        return 'KorrekturWerteStromerzeugung';
    }
}

export async function createNewKorrekturWerteStromerzeugung(): Promise<KorrekturWerteStromerzeugung> {
    const korrekturwertestromerzeugung = createModel(KorrekturWerteStromerzeugung, {});

    await korrekturwertestromerzeugung.save();
    return korrekturwertestromerzeugung;
}

export class KorrekturWerteStromerzeugungCollection extends BaseCollection<KorrekturWerteStromerzeugung> {
    protected modelCls = KorrekturWerteStromerzeugung;

    public getModelClassName(): string {
        return 'KorrekturWerteStromerzeugung';
    }
}
